module.exports = __webpack_public_path__ + "static/media/wd_page_area02_img_cn.feecdc53.png";